"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledIs = _interopRequireWildcard(require("styled-is"));
var _useDetectScroll2 = require("../common/useDetectScroll");
var _HBIconButton = _interopRequireDefault(require("../HBIconButton/HBIconButton"));
var _ArrowLeft = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowLeft16"));
var _ArrowRight = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowRight16"));
var _shared = require("../../utils/shared.utils");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBCarouselContainer = function HBCarouselContainer(_ref) {
  var className = _ref.className,
    children = _ref.children,
    gap = _ref.gap,
    _ref$spaceWhenNotScro = _ref.spaceWhenNotScrolled,
    spaceWhenNotScrolled = _ref$spaceWhenNotScro === void 0 ? 0 : _ref$spaceWhenNotScro;
  var containerRef = (0, _react.useRef)();
  var _useDetectScroll = (0, _useDetectScroll2.useDetectScroll)({
      elementRef: containerRef,
      direction: 'horizontal',
      spaceWhenNotScrolled: spaceWhenNotScrolled
    }),
    isScrolled = _useDetectScroll.isScrolled,
    isScrolledToEnd = _useDetectScroll.isScrolledToEnd;
  var scroll = function scroll(direction) {
    var _containerRef$current;
    var scrollSize = (_containerRef$current = containerRef.current.firstElementChild) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetWidth;
    containerRef.current.scrollBy({
      left: direction === 'start' ? -scrollSize : scrollSize,
      behavior: 'smooth'
    });
  };
  var showStartScrollAvailable = isScrolled;
  var showEndScrollAvailable = !isScrolledToEnd;
  return /*#__PURE__*/_react["default"].createElement(Container, {
    $showStartScrollAvailable: showStartScrollAvailable,
    $showEndScrollAvailable: showEndScrollAvailable,
    $isScrolledToEnd: isScrolledToEnd,
    $spaceWhenNotScrolled: spaceWhenNotScrolled
  }, /*#__PURE__*/_react["default"].createElement(StyledHBIconButton, (0, _extends2["default"])({
    icon: _ArrowLeft["default"],
    label: "scroll start button",
    onClick: function onClick() {
      return scroll('start');
    },
    testId: "carousel-scroll-start--button",
    inert: !showStartScrollAvailable,
    $isVisible: showStartScrollAvailable
  }, iconButtonProps)), /*#__PURE__*/_react["default"].createElement(ScrollableContainer, {
    className: className,
    $gap: gap,
    ref: containerRef,
    $showStartScrollAvailable: showStartScrollAvailable,
    $showEndScrollAvailable: showEndScrollAvailable,
    "data-testid": "carousel-scrollable-container"
  }, children), /*#__PURE__*/_react["default"].createElement(StyledHBIconButton, (0, _extends2["default"])({
    icon: _ArrowRight["default"],
    label: "scroll end button",
    onClick: function onClick() {
      return scroll('end');
    },
    testId: "carousel-scroll-end--button",
    inert: !showEndScrollAvailable,
    $isVisible: showEndScrollAvailable
  }, iconButtonProps)));
};
var _default = exports["default"] = HBCarouselContainer; // -------------------------------- Styles -------------------------------- //
var iconButtonProps = {
  buttonTheme: 'neutral-floating',
  size: 'xs'
};
var StyledHBIconButton = (0, _styledComponents["default"])(_HBIconButton["default"]).attrs(_shared.inertAttr).withConfig({
  displayName: "HBCarouselContainer__StyledHBIconButton",
  componentId: "sc-ac31xa-0"
})(["position:absolute;z-index:2;top:50%;transform:translateY(-50%);opacity:0;transition:opacity 0.15s;&:first-of-type{left:8px;}&:last-of-type{right:8px;}", ""], (0, _styledIs["default"])('$isVisible')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        opacity: 1;\n    "]))));
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBCarouselContainer__Container",
  componentId: "sc-ac31xa-1"
})(["position:relative;width:100%;overflow:hidden;transition:padding 0.15s;", " ", ""], (0, _styledIs.isNot)('$showStartScrollAvailable')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n        padding-left: ", "px;\n    "])), function (_ref2) {
  var $spaceWhenNotScrolled = _ref2.$spaceWhenNotScrolled;
  return $spaceWhenNotScrolled;
}), (0, _styledIs["default"])('$isScrolledToEnd')(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n        padding-right: ", "px;\n    "])), function (_ref3) {
  var $spaceWhenNotScrolled = _ref3.$spaceWhenNotScrolled;
  return $spaceWhenNotScrolled;
}));
var ScrollableContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBCarouselContainer__ScrollableContainer",
  componentId: "sc-ac31xa-2"
})(["display:flex;gap:", "px;overflow-x:auto;scroll-snap-type:x mandatory;scroll-behavior:smooth;> *{scroll-snap-align:start;}&::before,&::after{content:'';position:absolute;z-index:1;top:0;bottom:0;width:16px;transition:opacity 0.15s;}&::before{left:0;background:linear-gradient( to right,rgba(244,245,246,1),rgba(244,245,246,0) );opacity:", ";}&::after{right:0;background:linear-gradient( to left,rgba(244,245,246,1),rgba(244,245,246,0) );opacity:", ";}"], function (props) {
  return props.$gap;
}, function (props) {
  return props.$showStartScrollAvailable ? 1 : 0;
}, function (props) {
  return props.$showEndScrollAvailable ? 1 : 0;
});
//# sourceMappingURL=HBCarouselContainer.js.map